<template>
  <div>
    <div v-if="!exitOption">
      <button
        v-on:click="exitClicked"
        class="cursor-pointer"
        style="float: right"
        aria-label="Exit"
      >
        <span
          style="width: 36px; height: 36px; background: white"
          class="w-auto rounded-full bg-grey-50 block p-3"
        >
          <svg
            width="16"
            height="13"
            viewBox="0 0 16 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.7786 7.07507L10.445 12.7616C9.96875 13.2693 9.14331 12.9139 9.14331 12.1862V8.93674H4.82564C4.40339 8.93674 4.06369 8.57456 4.06369 8.12437V4.87491C4.06369 4.42472 4.40339 4.06255 4.82564 4.06255H9.14331V0.813085C9.14331 0.0887261 9.96557 -0.270068 10.445 0.23766L15.7786 5.92421C16.0738 6.24239 16.0738 6.75689 15.7786 7.07507ZM6.09554 12.5924V11.2384C6.09554 11.015 5.9241 10.8323 5.71457 10.8323H3.04777C2.48584 10.8323 2.03185 10.3482 2.03185 9.7491V3.25018C2.03185 2.65106 2.48584 2.16703 3.04777 2.16703H5.71457C5.9241 2.16703 6.09554 1.98424 6.09554 1.76084V0.406902C6.09554 0.183502 5.9241 0.00071991 5.71457 0.00071991H3.04777C1.36515 0.00071991 0 1.45621 0 3.25018V9.7491C0 11.5431 1.36515 12.9986 3.04777 12.9986H5.71457C5.9241 12.9986 6.09554 12.8158 6.09554 12.5924Z"
              fill="#0C0707"
            />
          </svg>
        </span>
      </button>
    </div>
    <div v-if="exitOption">
      <div v-on:click="exitClosed" class="helpOverlay"></div>
    </div>
    <div
      v-if="exitOption"
      class="exitDialog dark:bg-purple-600 border-2 dark:text-white"
      id="exit"
    >
      <p class="pargraphs">
        You are about to leave the Wellness Services Navigator, are you sure?
      </p>
      <button class="exitNavButton" v-on:click="exitNav">Yes, leave</button>
      <button class="continuteNavButton" v-on:click="exitClosed">
        No, continue
      </button>
    </div>
  </div>
</template>

<script>
//import store from "../store";
export default {
  name: "Loader",
  data: function () {
    return {
      exitOption: false,
    };
  },
  methods: {
    exitNav() {
      location.reload();

      if (window.location.href.indexOf("?crisis=true") != -1) {
        let url = window.location.href.split("/?");
        window.location.href = url[0];
      }
    },

    exitClicked() {
      this.exitOption = true;
    },

    exitClosed() {
      var menu = document.getElementById("exit");

      menu.classList.add("slide-right");
      setTimeout(() => {
        this.exitOption = false;
        menu.classList.remove("slide-right");
      }, 500);
    },
  },
};
</script>

<style scoped>
.slide-right {
  animation: 0.5s ease-out 0s 1 slide-up;
}
@keyframes slide-up {
  100% {
    transform: translateY(-200%);
  }
}
</style>
>
